import React from 'react';
import {Link} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import {PropTypes} from 'prop-types';
import {LoadingIndicator} from '../components/loading-indicator/loading-indicator.jsx';
import {SearchAndFilter} from '../components/my-apps/search-and-filter.jsx';
import {SortableAppTable} from '../components/my-apps/sortable-app-table.jsx';
import AlertMessage from '../components/alert-message/alert-message.jsx';
import {NoResults} from 'fn-common-ui';
import config from 'config';


@inject('store')
@observer
export class MyAppsPage extends React.Component {

	static propTypes = {
		store: PropTypes.object.isRequired
	};

	constructor(props) {
		super(props);
		this.headerStore = this.props.store.headerStore;
		this.myAppsStore = this.props.store.myAppsStore;
		this.joyrideStore = this.props.store.joyrideStore;

		this.unreleasedTableColumns = [
			{
				title: 'App',
				property: 'app_name',
				width: '4'
			},
			{
				title: 'Platform',
				property: 'platform',
				width: '2'
			},
			{
				title: 'Last Update',
				property: 'custom_metadata.lastActionDate',
				type: 'date',
				width: '2'
			},
			{
				title: 'Status',
				property: 'custom_metadata.status',
				width: '2'
			},
			{
				title: 'Submitted by',
				property: 'custom_metadata.haloDeveloperFirstName',
				width: '2'
			}
		];
		this.releasedTableColumns = [
			{
				title: 'App',
				property: 'app_name',
				width: '4'
			},
			{
				title: 'Platform',
				property: 'platform',
				width: '1'
			},
			{
				title: 'Release Date',
				property: 'custom_metadata.release_date',
				type: 'date',
				width: '1'
			},
			{
				title: 'Status',
				property: 'custom_metadata.status',
				width: '2'
			},
			{
				title: 'Ratings',
				property: 'rating',
				width: '1'
			},
			{
				title: 'Statistics',
				width: '1'
			},
			{
				title: 'Submitted by',
				property: 'custom_metadata.haloDeveloperFirstName',
				width: '2'
			}
		]

		this.myAppsStore.resetApps();
	}

	componentDidMount() {
		this.headerStore.setCurrentSection('my-apps');
		this.myAppsStore.getMyApps();
	}

	componentDidUpdate() {
		this.joyrideStore.updatePlacement();
	}

	componentWillUnmount() {
		this.headerStore.clearCurrentSection();
	}

	render() {
		return (
			<div className="my-apps-wrapper">
				<div className="hero-banner">
					<div className="container">
						<div className="hero-text col-12 col-lg-10 offset-lg-1">
							<h1>Submit and Manage Your Apps</h1>
							<p>
								<a href={config.resourceCatalog} target="_blank" rel="noopener noreferrer" className="resources-link">
									<span className="sr-only">Download</span>
									<span>Resources</span>
									<i className="icon-external-site white" aria-hidden="true"></i>
								</a>
							</p>
						</div>
					</div>
					<Link role="button" to="/new-application/app-details/" className="submit-new-app-button as-tab hero-tab walkthrough-submit-new-app" >
						<span>Submit New App</span>
						<i className="icon-arrowRight white" aria-hidden="true"></i>
					</Link>
				</div>
				<div className="container">
					<h2>My Apps</h2>
					<AlertMessage />
					<SearchAndFilter
						store={this.myAppsStore}
						forceOpen={this.myAppsStore.forceOpenSearch} />
					{this.myAppsStore.isLoading || (this.myAppsStore.released.length > 0 || this.myAppsStore.unReleased.length > 0)
							?	(<LoadingIndicator isLoading={this.myAppsStore.isLoading}>
									<SortableAppTable store={this.myAppsStore} userStore={this.props.store.userStore} caption="Unreleased" list="unReleased" id="list-unreleased" className="walkthrough-unreleased-apps" columns={this.unreleasedTableColumns}/>
									<SortableAppTable store={this.myAppsStore} userStore={this.props.store.userStore} caption="Released" list="released" id="list-released" className="walkthrough-released-apps" columns={this.releasedTableColumns}/>
								</LoadingIndicator>)
							: <NoResults
								title="No Results"
								text="There are no results to display. Please retry your search or reset the filters" />
					}
				</div>
			</div>
		);
	}
}
